import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import ChecksPrint from "./ChecksPrint";
import Print from "../assets/icons/ico-print.svg";

import './PrintPage.css';

export default class PrintPage extends Component {
  static propTypes = {
    match: PropTypes.shape({
      url: PropTypes.string,
    }).isRequired,
  }

  handlePrint = (e) => {
    e.preventDefault();
    window.print();
  }

  render() {
    const { match } = this.props;
    return (
      <div className="PrintPage">
        <button className="hidePrint" onClick={this.handlePrint}>
          Print <img src={Print} alt="Print"/>
        </button>
        <Switch>
          <Route path={`${match.url}/checks`} exact component={ChecksPrint} />
        </Switch>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PrintPage.jsx